import type { AuditIntegrationCase } from '../../../types/features/storeDetails/legacyAudits';

export const getStoreConfigurationFlags = (selectedStore: any) => {
  const lottoRaw = selectedStore?.lotto_authorized;
  const isLottoAuthorized =
    lottoRaw === true ||
    lottoRaw === 1 ||
    lottoRaw === '1' ||
    String(lottoRaw).toLowerCase() === 'true';

  const normalizedPosType = String(selectedStore?.pos_type ?? '').trim().toLowerCase();
  const hasPosType =
    normalizedPosType !== '' &&
    normalizedPosType !== 'n/a' &&
    normalizedPosType !== 'na' &&
    normalizedPosType !== 'none' &&
    normalizedPosType !== 'null' &&
    normalizedPosType !== 'undefined';

  const isBothConnected = Boolean(isLottoAuthorized && hasPosType);
  const isBothNotConnected = Boolean(!isLottoAuthorized && !hasPosType);
  const isLottoConnectedOnly = Boolean(isLottoAuthorized && !hasPosType);
  const isPOSConnectedOnly = Boolean(!isLottoAuthorized && hasPosType);
  const integrationCase: AuditIntegrationCase = isBothConnected
    ? 'bothConnected'
    : isLottoConnectedOnly
      ? 'lottoConnectedOnly'
      : isPOSConnectedOnly
        ? 'posConnectedOnly'
        : 'bothNotConnected';

  return {
    integrationCase,
    isBothConnected,
    isBothNotConnected,
    isLottoConnectedOnly,
    isPOSConnectedOnly,
    isLottoAuthorized,
    hasPosType,
  };
};

export const getLegacyDynamicColumns = (selectedStore: any): string[] => {
  const { integrationCase } = getStoreConfigurationFlags(selectedStore);

  if (integrationCase === 'bothConnected') {
    return ['Scratcher Counts', 'Scratcher Sales', 'Lotto Sales', 'Payout', 'Final'];
  }

  if (integrationCase === 'bothNotConnected') {
    return ['Scratcher QTY', 'Scratcher Sales'];
  }

  return ['Scratcher Counts', 'Scratcher Sales', 'Lotto Sales', 'Payouts Lotto + Scratchers'];
};

export const getLegacyAuditTableColumnCount = (selectedStore: any): number => {
  const dynamicColumns = getLegacyDynamicColumns(selectedStore).length;
  return 2 + 6 + dynamicColumns + 1;
};

export const getLegacyReconciliationColumnIndex = (selectedStore: any): number => {
  return getLegacyAuditTableColumnCount(selectedStore) - 1;
};

export const getLegacyConditionalBorderColumns = (selectedStore: any): number[] => {
  const { integrationCase } = getStoreConfigurationFlags(selectedStore);

  if (integrationCase === 'bothConnected') {
    return [0, 1, 7, 12];
  }

  if (integrationCase === 'bothNotConnected') {
    return [0, 1, 7, 9];
  }

  return [0, 1, 7, 11];
};
